import { render, staticRenderFns } from "./ReactWrapper.vue?vue&type=template&id=2d937afc&"
import script from "./ReactWrapper.vue?vue&type=script&lang=ts&"
export * from "./ReactWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports